/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />

namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MaterialPaymentItemsDialog extends _Ext.ItemEditorDialog<MaterialPaymentItemsRow> {
        protected getFormKey() { return MaterialPaymentItemsForm.formKey; } 
        protected getLocalTextPrefix() { return MaterialPaymentItemsRow.localTextPrefix; } 
        public form = new MaterialPaymentItemsForm(this.idPrefix);
         
        constructor() {
            super();
             

            // **** On Pieces Change Event **** 
            this.form.Pieces.changeSelect2(e => {
                var pieces = parseInt(this.form.Pieces.value.toString());                
                var netamount = parseFloat(this.form.NetAmount.value.toString());
                this.form.GrossAmount.value = (pieces * netamount);
            });

            // **** On NetAmount Change Event **** 
            this.form.NetAmount.changeSelect2(e => {
                var pieces = parseInt(this.form.Pieces.value.toString());
                var netamount = parseFloat(this.form.NetAmount.value.toString());
                this.form.GrossAmount.value = (pieces * netamount);
            });
            this.form.HasBom.changeSelect2(e => {
                if (this.form.HasBom.value) {
                    q.hideField(this.form.KaratId)
                    q.hideField(this.form.Purity)
                }
                else {
                    q.showAndSetRequiredField(this.form.KaratId)
                    q.showAndSetRequiredField(this.form.Purity)
                    q.showAndSetRequiredField(this.form.MetalId)
                }

            })
            var min = 0, max = 0, std = 0;
            this.form.KaratId.changeSelect2(e => {
                var KaratId = Q.toId(this.form.KaratId.value);
                var purity: OMS.AttributeMasterRow;
                OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                    purity = response.Entity
                }, { async: false });
                min = purity.MinPurity;
                max = purity.MaxPurity;
                std = purity.StdPurity;
                this.form.Purity.value = std;
            });
            this.form.Purity.change(e => {
                var current = this.form.Purity.value;
                if (current < min || current > max) {
                    Q.alert("Enter Purity between  " + min.toString() + "  to  " + max.toString());
                    this.form.Purity.value = std;
                }
            });
           

            // **** On Wastage % Change Event **** 
            //this.form.WstPer.changeSelect2(e => {
            //    this.form.WstWt.value = this.form.NetWeight.value * ((this.form.WstPer.value) / 100);

            //});

 
            // **** On Product Code Change Event **** 
            //Validate Product Code for Duplication 
            this.form.ProductCode.changeSelect2(e => {
                try {
                    let id;
                    OMS.ProductMasterService.CustomList({ ProductCode: this.form.ProductCode.value.toUpperCase() },
                        response => {
                            id = response.Entities[0];
                        }, { async: false });
                    if (id.ProductId != null || id.ProductId > 0) {
                        Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                        this.form.ProductCode.value = "";
                        this.form.ProductCode.element.focus();
                        return;

                    }
                }
                catch (undefined) {

                }
            });

        }

        afterLoadEntity() {
            super.afterLoadEntity();
            Serenity.EditorUtils.setReadonly(this.form.ProductCode.element, true);
            Serenity.EditorUtils.setReadonly(this.form.ProductName.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.HSN.element, true);
            Serenity.EditorUtils.setReadonly(this.form.ProductCode.element, true);
            Serenity.EditorUtils.setReadonly(this.form.ProductTypeId.element, true);
            Serenity.EditorUtils.setReadonly(this.form.CategoryId.element, true);
            Serenity.EditorUtils.setReadonly(this.form.SubCategoryId.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.CollectionId.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.BrandId.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.SuperTypeId.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.UnitLabour.element, true);
            Serenity.EditorUtils.setReadonly(this.form.Weight.element, true);
            Serenity.EditorUtils.setReadonly(this.form.NetWeight.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.StonePieces.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.StoneWeight.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.DiamondPieces.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.DiamondWeight.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.OtherPieces.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.OtherWeight.element, true);
            Serenity.EditorUtils.setReadonly(this.form.ProductCode.element, true);


   //         this.form.BOMDetails.getGridField().find('.grid-toolbar').attr("style", "display:none;");

            this.dialogTitle = "View: " + this.form.ProductCode.value;

     //       this.form.LaborDetails.setOwnerEntity(this.entity);
            if (this.entityId != undefined) {
                if (!this.form.HasBom.value) {
                    this.HasBom = false;
                    //q.hideEditorCategory(this.form.BOMDetails);
                    //q.hideField(this.form.BOMDetails);
                    this.form.Weight.value = this.entity.Weight == 0 ? 1 : this.entity.Weight;
                }
            }

        }
         
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            btns.splice(Q.indexOf(btns, x => x.cssClass == "undo-delete-button"), 1);
            btns.splice(Q.indexOf(btns, x => x.cssClass == "localization-button"), 1);
            btns.splice(Q.indexOf(btns, x => x.cssClass == "clone-button"), 1);
             
            return btns;
        }
         
    }
}